import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { c as _c } from "react-compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
var ActionWrapper = /*#__PURE__*/_styled('div', {
  target: "easneun0",
  label: "ActionWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "rm0ay5",
  styles: "background:var(--podium-cds-color-bg-primary);padding-top:var(--podium-cds-size-spacing-l);width:100%;display:flex;flex-direction:row-reverse;"
} : {
  name: "rm0ay5",
  styles: "background:var(--podium-cds-color-bg-primary);padding-top:var(--podium-cds-size-spacing-l);width:100%;display:flex;flex-direction:row-reverse;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var FooterSlot = function FooterSlot(t0) {
  var $ = _c(5);
  var showPickupIneligibleMessage = t0.showPickupIneligibleMessage,
    onClose = t0.onClose;
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      stringKey: "label.close",
      primaryValue: "Close",
      description: "Modal close button accessibility string"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var closeButtonLabel = useI18nString(t1);
  var t2;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = {
      stringKey: "cta.save",
      primaryValue: "Save",
      description: "Save button"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  var saveButtonLabel = useI18nString(t2);
  var buttonLabel = showPickupIneligibleMessage ? closeButtonLabel : saveButtonLabel;
  var t3;
  if ($[2] !== buttonLabel || $[3] !== onClose) {
    t3 = /*#__PURE__*/React.createElement(ActionWrapper, null, /*#__PURE__*/React.createElement(ButtonStyled, {
      appearance: "primary",
      background: "light",
      size: "medium",
      type: "button",
      Component: "button",
      onClick: onClose
    }, buttonLabel));
    $[2] = buttonLabel;
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
FooterSlot.propTypes = {
  showPickupIneligibleMessage: PropTypes.bool,
  onClose: PropTypes.func
};
export default FooterSlot;